<mat-card class="contribute contribute--free border-primary">
  <div class="my-3">
    <span class="mat-body-2">
      {{ freeSupportText(vaki?.category?.brand) }}
    </span>
  </div>
  <lib-vakers-vakis-ui-support-form
    [currentCurrency]="currentCurrency"
    [vaki]="vaki"
    [currencies]="currencies"
    [available]="available"
    (currencyChange)="inputCurrencyChange($event)"
  ></lib-vakers-vakis-ui-support-form>
</mat-card>
